// Copyright (c) MobiFactory. All rights reserved.
// This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
// See LICENSE.txt file in the project root for full license information.

import axios from "axios";

const BASE_SIRENE_URL = "https://entreprise.data.gouv.fr/api/sirene";

export default {
  /**
   * Searches from SIRET in the SIRENE database
   * @param {string} searchString - Search string
   * @returns {any} Response data
   */
  async searchFromSiret(searchString: string) {
    return await axios.get(BASE_SIRENE_URL + "/v1/siret/" + encodeURIComponent(searchString), {
      validateStatus: () => true,
    });
  },

  /**
   * Searches from SIREN in the SIRENE database
   * @param {string} searchString - Search string
   * @returns {any} Response data
   */
  async searchFromSiren(searchString: string) {
    return await axios.get(BASE_SIRENE_URL + "/v1/siren/" + encodeURIComponent(searchString), {
      validateStatus: () => true,
    });
  },

  /**
   * Searches in the SIRENE database
   * @param {string} searchString - Search string
   * @param {number|null} page - Result page index
   * @returns {any} Response data
   */
  async search(searchString: string, page: number | null) {
    return await axios.get(
      BASE_SIRENE_URL + "/v1/full_text/" + encodeURIComponent(searchString) + (page ? "?page=" + page : ""),
      { validateStatus: () => true }
    );
  },
};
